<template>
  <v-container>
    <h2>Registration</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-divider></v-divider>
        <app-personal :personal_information="personal_information" :image_src="image_src" />
        <app-contact :contact_information="contact_information" />
        <v-row>
          <v-col cols="12" md="6">
            <app-personality-test :personal_information="personal_information"
              :personality_test_src="personality_test_src" />
          </v-col>
          <v-col cols="12" md="6">
            <app-video :personal_information="personal_information" />
          </v-col>
        </v-row>
        <app-job :job_information="job_information" />
        <app-language :lang_list="languages" :remove_langs="remove_languages" />
        <app-skill :skill_list="skills" :remove_skills="remove_skills" />
        <app-experience :experience_list="experiences" :remove_experiences="remove_experiences" />
        <app-education :education_list="educations" :remove_educations="remove_educations" />
        <v-divider></v-divider>
        <h4>Bank account information</h4>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="other_information.bank_name" label="Bank name" outlined dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="other_information.bank_account_name" label="Bank account name" outlined dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="other_information.bank_account_number" label="Bank account number" outlined dense />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn class="mx-2" small color="orange" dark @click="updateSupporter()">
            Update
          </v-btn>
          <v-btn class="mx-2" small exact :to="{ name: 'supporter-list' }">
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "SupporterEdit",
  components: {
    AppPersonal: () => import('../components/personal'),
    AppPersonalityTest: () => import('../components/personality_test'),
    AppVideo: () => import('../components/video'),
    AppContact: () => import('../components/contact'),
    AppJob: () => import('../components/job'),
    AppSkill: () => import('../components/skill'),
    AppExperience: () => import('../components/experience'),
    AppLanguage: () => import('../components/language'),
    AppEducation: () => import('../components/education'),
  },
  data: () => ({
    supporter_id: null,
    img_base_url: process.env.VUE_APP_IMG_BASE_URL,
    image_src: '',
    personality_test_src: '',
    skills: [],
    experiences: [],
    languages: [],
    educations: [],
    remove_skills: [],
    remove_experiences: [],
    remove_languages: [],
    remove_educations: [],
    personal_information: {
      profile_image: null,
      profile_iamge_id: null,
      profile_image_url: null,
      firstname: null,
      internal_code: null,
      display_name: null,
      gender: null,
      birthdate: null,
      weight: null,
      height: null,
      marriage_status: null,
      nationality: null,
      religion: null,
      personal_id: null,
      passport_id: null,
      driving_license: false,
      motorbike_driving_license: false,
      vaccine: false,
      work_permit: false,
      work_permit_expiration_date: null,
      video_url: null
    },
    contact_information: {
      phone_number: null,
      line_id: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_location: null,
      emergency_contact_person: null,
      emergency_contact_phone: null,
    },
    job_information: {
      job_roles: [],
      job_live: null,
      job_type: null,
      job_location: null,
      job_request_area: null,
      expected_salary: null,
      reference_person: null,
      reference_contact: null,
      active: false,
      remark: null,
      comment: null,
      is_pet: null,
      pet_detail: null,
      is_app: null,
      app_available_days: [],
      app_available_time: null
    },
    other_information: {
      bank_name: null,
      bank_account_name: null,
      bank_account_number: null
    }
  }),
  async mounted() {
    let id = this.$route.params.id
    await this.getSupporter(id)
  },
  methods: {
    requireField() {
      if (!this.personal_information.firstname) {
        alert('Please fill in firstname')
        return false
      }
      if (this.personal_information.personal_id && !/\d/.test(this.personal_information.personal_id)) {
        alert('Personal ID must be digits only')
        return false
      }
      if (this.personal_information.personal_id && this.personal_information.personal_id.length < 13) {
        alert('Personal ID must be 13 characters')
        return false
      }
      return true
    },
    async getSupporter(id) {
      this.supporter_id = id
      try {
        const supporter = await this.$http.get(`/back-office/supporters/${this.supporter_id}`, authHeader())
        this.personal_information.profile_image_url = supporter.data.profile_image_url
        this.personal_information.personality_test_url = supporter.data.personality_test_url
        this.personal_information.firstname = supporter.data.firstname
        this.personal_information.internal_code = supporter.data.internal_code
        this.personal_information.display_name = supporter.data.display_name
        this.personal_information.gender = supporter.data.gender
        this.personal_information.birthdate = supporter.data.birthdate
        this.personal_information.weight = supporter.data.weight
        this.personal_information.height = supporter.data.height
        this.personal_information.marriage_status = supporter.data.marriage_status
        this.personal_information.nationality = supporter.data.nationality
        this.personal_information.religion = supporter.data.religion
        this.personal_information.personal_id = supporter.data.personal_id
        this.personal_information.passport_id = supporter.data.passport_id
        this.personal_information.driving_license = supporter.data.driving_license
        this.personal_information.motorbike_driving_license = supporter.data.motorbike_driving_license
        this.personal_information.vaccine = supporter.data.vaccine
        this.personal_information.work_permit = supporter.data.work_permit
        this.personal_information.work_permit_expiration_date = supporter.data.work_permit_expiration_date
        this.personal_information.video_url = supporter.data.video_url
        this.contact_information.phone_number = supporter.data.phone_number
        this.contact_information.line_id = supporter.data.line_id
        this.contact_information.address_location = supporter.data.address_location
        this.contact_information.address_sub_district = supporter.data.address_sub_district
        this.contact_information.address_district = supporter.data.address_district
        this.contact_information.address_province = supporter.data.address_province
        this.contact_information.emergency_contact_person = supporter.data.emergency_contact_person
        this.contact_information.emergency_contact_phone = supporter.data.emergency_contact_phone
        this.job_information.job_roles = supporter.data.job_roles
        this.job_information.job_live = supporter.data.job_live
        this.job_information.job_type = supporter.data.job_type
        this.job_information.expected_salary = supporter.data.expected_salary
        this.job_information.job_location = supporter.data.job_location
        this.job_information.job_request_area = supporter.data.job_request_area
        this.job_information.active = supporter.data.active
        this.job_information.remark = supporter.data.remark
        this.job_information.comment = supporter.data.comment
        this.other_information.bank_name = supporter.data.bank_name
        this.other_information.bank_account_name = supporter.data.bank_account_name
        this.other_information.bank_account_number = supporter.data.bank_account_number
        this.job_information.reference_person = supporter.data.reference_person
        this.job_information.reference_contact = supporter.data.reference_contact
        this.educations = supporter.data.SupporterEducations
        this.languages = supporter.data.SupporterLanguages
        this.skills = supporter.data.SupporterSkills
        this.experiences = supporter.data.SupporterExperiences
        this.job_information.is_pet = supporter.data.is_pet
        this.job_information.pet_detail = supporter.data.pet_detail
        this.image_src = supporter.data.profile_image_url
        this.personality_test_src = supporter.data.personality_test_url || ''
        this.job_information.is_app = supporter.data.is_app
        this.job_information.app_available_days = (supporter.data.app_available_days && supporter.data.app_available_days != '') ? supporter.data.app_available_days.split(',') : []
        this.job_information.app_available_time = supporter.data.app_available_time
      } catch (error) {
        console.log(error)
      }
    },
    async updateSupporter() {
      if (this.requireField()) {
        try {
          let supporter = {
            firstname: this.personal_information.firstname,
            internal_code: this.personal_information.internal_code,
            display_name: this.personal_information.display_name,
            gender: this.personal_information.gender,
            birthdate: this.personal_information.birthdate,
            weight: this.personal_information.weight,
            height: this.personal_information.height,
            marriage_status: this.personal_information.marriage_status,
            nationality: this.personal_information.nationality,
            religion: this.personal_information.religion,
            personal_id: this.personal_information.nationality == 'Thai' ? this.personal_information.personal_id : null,
            passport_id: this.personal_information.nationality != 'Thai' ? this.personal_information.passport_id : null,
            driving_license: this.personal_information.driving_license,
            motorbike_driving_license: this.personal_information.motorbike_driving_license,
            vaccine: this.personal_information.vaccine,
            work_permit: this.personal_information.nationality != 'Thai' ? this.personal_information.work_permit : null,
            work_permit_expiration_date: this.personal_information.nationality != 'Thai' ? this.personal_information.work_permit_expiration_date : null,
            video_url: this.personal_information.video_url,
            phone_number: this.contact_information.phone_number,
            line_id: this.contact_information.line_id,
            address_sub_district: this.contact_information.address_sub_district,
            address_district: this.contact_information.address_district,
            address_province: this.contact_information.address_province,
            address_location: this.contact_information.address_location,
            emergency_contact_person: this.contact_information.emergency_contact_person,
            emergency_contact_phone: this.contact_information.emergency_contact_phone,
            job_roles: this.job_information.job_roles.toString(),
            job_live: this.job_information.job_live,
            job_type: this.job_information.job_type,
            expected_salary: this.job_information.expected_salary,
            job_location: this.job_information.job_location,
            job_request_area: this.job_information.job_request_area,
            active: this.job_information.active,
            remark: this.job_information.remark,
            comment: this.job_information.comment,
            bank_name: this.other_information.bank_name,
            bank_account_name: this.other_information.bank_account_name,
            bank_account_number: this.other_information.bank_account_number,
            reference_person: this.job_information.reference_person,
            reference_contact: this.job_information.reference_contact,
            educations: this.educations,
            languages: this.languages,
            skills: this.skills,
            experiences: this.experiences,
            remove_skills: this.remove_skills,
            remove_educations: this.remove_educations,
            remove_experiences: this.remove_experiences,
            remove_languages: this.remove_languages,
            profile_image_url: this.personal_information.profile_image_url,
            personality_test_url: this.personal_information.personality_test_url,
            is_pet: this.job_information.is_pet,
            pet_detail: this.job_information.is_pet ? this.job_information.pet_detail : null,
            is_app: this.job_information.is_app,
            app_available_days: this.job_information.is_app ? this.job_information.app_available_days.toString() : null,
            app_available_time: this.job_information.is_app ? this.job_information.app_available_time : null
          }
          await this.$http.put(`/back-office/supporters/${this.supporter_id}`, supporter, authHeader())
          this.$router.push({ name: 'supporter-list' })
        } catch (err) {
          console.log(err)
          alert("Something went wrong")
        }
      } else {
        console.log('gosh')
      }
    },
    async removeProfile() {
      try {
        if (!this.personal_information.profile_image)
          return;
        else {
          await this.$http.delete(`/back-office/upload/files/${this.personal_information.profile_iamge_id}`, authHeader())
          this.personal_information.profile_iamge_id = null
          return;
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>

<style>
.card {
  padding: 15px 30px 0;
  border-radius: 5px;
  margin-bottom: 7px;
}

.grey-card {
  background-color: #f9f9f9;
}
</style>
